<template>
    <div>
        <loading :active.sync="is_loading" 
        :can-cancel="false" 
        :is-full-page="true"></loading>
        <Navbar />
        <div class="container-fluid">
            <SidebarSarpras/>
            <main class="main" id="main">
                <Breadcrumb :links="[{url: '/dashboard', text:'Home'}, {url: '#', text: 'Riwayat Inspeksi Sarana dan Prasana'}, {url: '#', text: 'Tambah'}]"/>
                <h2><b>Tambah Inspeksi</b></h2>
                <div class="card">
                    <div class="card-body">
                        <div class="form-group mb-3">
                            <label for="">Nomor Aset</label>
                            <input type="text" class="form-control" disabled v-model="structure.nomor_aset">
                        </div>
                        <div class="form-group mb-3">
                            <label for="">Nama Objek</label>
                            <input type="text" class="form-control" disabled v-model="structure.nama_objek">
                        </div>
                        <template v-if="structure.structure_type_id === 1">
                            <div class="form-group mb-3">
                                <label for="">Jenis Tanah</label>
                                <input type="text" class="form-control" disabled v-model="structure.land_type.name">
                            </div>
                            <div class="form-group mb-3">
                                <label for="">Jenis Aset</label>
                                <input type="text" class="form-control" disabled v-model="structure.asset_type.name">
                            </div>
                        </template>
                        <template v-else>
                            <div class="row">
                                <div class="col-md-6 col-12">
                                    <div class="form-group mb-3">
                                        <label for="">Jenis Bangunan</label>
                                        <input type="text" class="form-control" disabled v-model="structure.building_type.name">
                                    </div>
                                </div>
                                <div class="col-md-6 col-12">
                                    <div class="form-group mb-3">
                                        <label for="">Jenis Aset</label>
                                        <input type="text" class="form-control" disabled v-model="structure.building_category.name">
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div class="row">
                            <div class="col-md-6 col-12">
                                <div class="form-group mb-3">
                                    <label for="">Unit Kerja</label>
                                    <input type="text" class="form-control" disabled v-model="structure.work_unit.name">
                                </div>
                            </div>
                            <div class="col-md-6 col-12">
                                <div class="form-group mb-3">
                                    <label for="">Seksi</label>
                                    <input type="text" class="form-control" disabled v-model="structure.section.name">
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-3 col-12">
                                <div class="form-group">
                                    <label for="inspection_date">Tanggal Inspeksi</label>
                                    <input 
                                        type="date" 
                                        id="inspection_date"
                                        class="form-control" 
                                        v-model="inspection_date"
                                        required
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-2 col-12">
                                <div class="form-group">
                                    <label for="">Kondisi Fungsi</label>
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="kondisi_fungsi">
                                        <span class="input-group-text">%</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2 col-12">
                                <div class="form-group">
                                    <label for="">Kondisi Fisik</label>
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="kondisi_fisik">
                                        <span class="input-group-text">%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group mb-3">
                            <label for="">Penjelasan Kondisi</label>
                            <textarea v-model="penjelasan_kondisi" class="form-control"></textarea>
                        </div>
                        <div class="form-group mb-3">
                            <label for="">Riwayat Perbaikan</label>
                            <textarea v-model="riwayat_perbaikan" class="form-control"></textarea>
                        </div>
                        <div class="form-group mb-3">
                            <label for="">Layanan di Hilir Prasarana</label>
                            <input type="text" class="form-control" v-model="layanan_hilir">
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-3 col-12">
                                <div class="form-group">
                                    <label for="">Perkiraan Biaya Kerugian</label>
                                    <div class="input-group">
                                        <span class="input-group-text">Rp</span>
                                        <input type="text" class="form-control" v-model="biaya_kerugian">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 col-12">
                                <div class="form-group">
                                    <label for="">Perkiraan Biaya Perbaikan</label>
                                    <div class="input-group">
                                        <span class="input-group-text">Rp</span>
                                        <input type="text" class="form-control" v-model="biaya_perbaikan">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group mb-3">
                            <label for="">Skala Prioritas</label><br>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="skala" id="inlineRadio1" value="1" v-model="skala_prioritas">
                                <label class="form-check-label" for="inlineRadio1">Segera</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="skala" id="inlineRadio2" value="2" v-model="skala_prioritas">
                                <label class="form-check-label" for="inlineRadio2">Perlu</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="skala" id="inlineRadio3" value="3" v-model="skala_prioritas">
                                <label class="form-check-label" for="inlineRadio3">Dapat ditangguhkan</label>
                            </div>
                        </div>
                        <hr>
                        <button class="btn btn-primary me-2" @click="create"><i class="fa fa-save"></i> Simpan</button>
                        <router-link :to="{name: 'InspectionIndex', params: { id: $route.params.id }}" class="btn btn-danger"><i class="fa fa-times"></i> Batal</router-link>
                    </div>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
import Navbar from '../../../components/Navbar.vue'
import Breadcrumb from '../../../components/Breadcrumb.vue'
import Loading from 'vue-loading-overlay';
import moment from 'moment';
import 'vue-loading-overlay/dist/vue-loading.css'
import SidebarSarpras from '../../../components/SidebarSarpras.vue'
import axios from 'axios'
import { quillEditor } from 'vue-quill-editor'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
 

export default {
    components: {
        Navbar,
        Loading,
        Breadcrumb,
        SidebarSarpras,
        quillEditor
    },
    data(){
        return {
            is_loading: false,
            structure: {
                land_type: {},
                asset_type: {},
                building_type: {},
                building_category: {},
                work_unit: {},
                section: {}
            },
            inspection_date: moment().format('YYYY-MM-DD'),
            penjelasan_kondisi: "",
            riwayat_perbaikan: "",
            layanan_hilir: "",
            kondisi_fisik: null,
            kondisi_fungsi: null,
            biaya_kerugian: null,
            biaya_perbaikan: null,
            skala_prioritas: null
        }
    },
    methods: {
        create(){
            this.is_loading = true;
            const user = localStorage.getItem('name');
            const user_id = localStorage.getItem('id');
            const { id } = this.$route.params;

            axios.post(`${this.$endpoints.sarpras}/inspections`, {
                structure_id: id,
                inspection_date: this.inspection_date,
                kondisi_fungsi: this.kondisi_fungsi,
                kondisi_fisik: this.kondisi_fisik,
                penjelasan_kondisi: this.penjelasan_kondisi,
                riwayat_perbaikan: this.riwayat_perbaikan,
                layanan_hilir: this.layanan_hilir,
                biaya_kerugian: this.biaya_kerugian,
                biaya_perbaikan: this.biaya_perbaikan,
                skala_prioritas: this.skala_prioritas,
                user,
                user_id
            })
            .then(() => {
                this.$swal('Berhasil', 'Data inspeksi berhasil ditambahkan', 'success');

                this.$router.push({name: 'InspectionIndex', params: {id}})
            })
            .catch(() => {
                this.$swal('Gagal', 'Data inspeksi gagal ditambahkan', 'error');
            })
            .finally(() => {
                this.is_loading = false;
            });
        }
    },
    mounted(){
        axios.get(`${this.$endpoints.sarpras}/structures/${this.$route.params.id}`)
        .then(response => {
            this.structure = response.data;
        })
    }
}
</script>